import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const labels = { details: ["Upptäck produkten", "Explore this green"], shelf: ["Hållbarhet", "Shelf life"], color: ["Färg", "Colour"], taste: ["Smak", "Flavour"] };

function Rating({ label, value, language }) {
  if (!Number.isFinite(value)) return null;
  const score = Math.max(0, Math.min(3, value));
  return <span className="FarmProductRating" aria-label={`${label}: ${score} ${language === 0 ? "av" : "of"} 3`}>
    <span>{label}</span>
    <span className="FarmProductRatingBars" aria-hidden="true">{[0, 1, 2].map((index) => <i key={index}><b style={{ width: `${Math.max(0, Math.min(1, score - index)) * 100}%` }} /></i>)}</span>
  </span>;
}

export default function FarmProductItem({ item }) {
  const language = useSelector((state) => state.app.language);
  return <article className="FarmProductCard">
    <Link to={`/farm/product/${item.link}`} className="FarmProductCardLink" aria-label={`${labels.details[language]}: ${item.name[language]}`}>
      <span className="FarmProductCardImage"><img src={item.url} alt={item.name[language]} loading="lazy" /></span>
      <span className="FarmProductCardContent">
        <span className="FarmProductCardHeading"><span><strong>{item.name[language]}</strong>{item.latin && <em>{item.latin}</em>}</span>{item.icon && <img src={item.icon} alt="" loading="lazy" />}</span>
        <span className="FarmProductCardDescription">{item.subtitle[language]}</span>
        <span className="FarmProductCardRatings">
          <Rating label={labels.shelf[language]} value={item.rateStore} language={language} />
          <Rating label={labels.color[language]} value={item.rateTaste} language={language} />
          <Rating label={labels.taste[language]} value={item.rateSpicy} language={language} />
        </span>
        <span className="FarmProductCardAction">{labels.details[language]}<ArrowForwardIcon /></span>
      </span>
    </Link>
  </article>;
}
